import { Navigate, Outlet } from 'react-router'
import { useAppSelector } from '~/app/hooks'
import { selectAuth } from '~/redux/features'
import { JsxChildrenProps } from '~/components'
import { useLocation } from 'react-router-dom';

const GuestGuard = ({ children }: JsxChildrenProps) => {
  const { token } = useAppSelector(selectAuth)
  const { search } = useLocation()

  const queryParams = new URLSearchParams(search)
  const goUrl = queryParams.get('go')

  if (token)
    return (
      <Navigate
        to={goUrl ?? '/'}
        replace
      />
    )

  return <>{children}</>
}

export const GuestGuardOutlet = () => {
  const { token } = useAppSelector(selectAuth)
  const { search } = useLocation()

  const queryParams = new URLSearchParams(search)
  const goUrl = queryParams.get('go')
  if (token)
    return (
      <Navigate
        to={goUrl ?? '/'}
        replace
      />
    )

  return <Outlet />
}

export default GuestGuard
